module.exports = __webpack_public_path__ + "img/FixedLine.ecb26f4a.svg";